
import {createSlice} from '@reduxjs/toolkit'
import { fetchworkOrderApplicationStatus } from '../../action/master/workOrderApplicationStatusAction'

interface workOrderApplicationStatusState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: workOrderApplicationStatusState = {
  data: null,
  status: 'idle',
  error: null,
}

const workOrderApplicationStatusSlice = createSlice({
  name: 'workOrderApplicationStatus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchworkOrderApplicationStatus.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchworkOrderApplicationStatus.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchworkOrderApplicationStatus.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default workOrderApplicationStatusSlice.reducer
